
























import { Component, Prop, Vue } from 'vue-property-decorator';
@Component
export default class SearchSelect extends Vue {
  @Prop() options!: any;
  @Prop() obj!: object;
  @Prop() name!: string;
  @Prop() itemId!: any;
  @Prop() model!: string;
  @Prop() text!: string;
  @Prop() value!: string;
  @Prop(Function) changeSearchValue!: Function;
  showList: boolean = false;
  timer: any = null;
  mounted() {}
  onFocus() {
    this.showList = true;
  }
  onBlur() {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.showList = false;
    }, 50);
  }
  selectItem(text, value) {
    this.obj[this.itemId] = value;
    this.obj[this.name] = text;
    this.$emit('update:obj', this.obj);
  }
}
